import { useRef } from "react";

// Pill button with ripple effect
export function RippleButton({ children, className = "", variant = "primary", ...props }) {
  const ref = useRef(null);
  const onClick = (e) => {
    const btn = ref.current;
    const circle = document.createElement("span");
    const d = Math.max(btn.clientWidth, btn.clientHeight);
    const rect = btn.getBoundingClientRect();
    circle.style.width = circle.style.height = d + "px";
    circle.style.left = e.clientX - rect.left - d / 2 + "px";
    circle.style.top = e.clientY - rect.top - d / 2 + "px";
    circle.className = "ripple-span";
    btn.appendChild(circle);
    setTimeout(() => circle.remove(), 600);
    props.onClick?.(e);
  };
  const base = "ripple-btn font-heading font-semibold rounded-full transition-transform duration-200 active:scale-95 hover:-translate-y-0.5";
  const variants = {
    primary: "bg-woofsy-primary text-white shadow-[0_10px_30px_rgba(255,138,61,0.35)] hover:shadow-[0_14px_40px_rgba(255,138,61,0.5)] hover:bg-[#e8792c]",
    dark: "bg-woofsy-dark text-white shadow-lg",
    ghost: "glass text-woofsy-dark",
    accent: "bg-woofsy-accent text-woofsy-dark shadow-[0_10px_30px_rgba(159,232,112,0.4)]",
  };
  return (
    <button ref={ref} {...props} onClick={onClick} className={`${base} ${variants[variant]} ${className}`}>
      {children}
    </button>
  );
}
